// extracted by mini-css-extract-plugin
module.exports = {"navigation":"NavBar_navigation__36KT7","navigation-list":"NavBar_navigation-list__1KI5T"};